import apiService from "./apiService";

function qs(params = {}) {
  return new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== "")
  ).toString();
}

export const agentApi = {
  channels: {
    list: () => apiService.get("/agent/channels/"),
    create: (payload) => apiService.post("/agent/channels/", payload),
    delete: (id) => apiService.delete(`/agent/channels/${id}`),
    status: (id) => apiService.get(`/agent/channels/${id}/status`),
    setDefault: (id) => apiService.post(`/agent/channels/${id}/default`, {}),
    testSend: (id, payload) => apiService.post(`/agent/channels/${id}/test-send`, payload),
  },
  sessions: {
    list: (params = {}) => {
      const s = qs(params);
      return apiService.get(`/agent/sessions${s ? `?${s}` : ""}`);
    },
    get: (id) => apiService.get(`/agent/sessions/${id}`),
    create: (payload) => apiService.post("/agent/sessions/", payload),
    createBulk: (payload) => apiService.post("/agent/sessions/bulk", payload),
    sendMessage: (id, text) => apiService.post(`/agent/sessions/${id}/messages`, { text }),
    takeover: (id) => apiService.post(`/agent/sessions/${id}/takeover`, {}),
    returnToAgent: (id) => apiService.post(`/agent/sessions/${id}/return-to-agent`, {}),
    end: (id) => apiService.post(`/agent/sessions/${id}/end`, {}),
    resume: (id) => apiService.post(`/agent/sessions/${id}/resume`, {}),
    test: (payload = {}) => apiService.post("/agent/sessions/test", payload),
    exportExcel: async (params = {}) => {
      const s = qs(params);
      const endpoint = s ? `/agent/sessions/export?${s}` : "/agent/sessions/export";
      const { blob, filename } = await apiService.download(endpoint);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename || "conversas_wpp.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
      return { filename: filename || "conversas_wpp.xlsx" };
    },
  },
  playbooks: {
    list: () => apiService.get("/agent/playbooks/"),
    get: (id) => apiService.get(`/agent/playbooks/${id}`),
    create: (payload) => apiService.post("/agent/playbooks/", payload),
    patch: (id, payload) => apiService.patch(`/agent/playbooks/${id}`, payload),
    activate: (id) => apiService.post(`/agent/playbooks/${id}/activate`, {}),
  },
  steps: {
    list: (playbookId) => apiService.get(`/agent/playbooks/${playbookId}/steps`),
    create: (playbookId, payload) => apiService.post(`/agent/playbooks/${playbookId}/steps`, payload),
    patch: (playbookId, stepId, payload) => apiService.patch(`/agent/playbooks/${playbookId}/steps/${stepId}`, payload),
    delete: (playbookId, stepId) => apiService.delete(`/agent/playbooks/${playbookId}/steps/${stepId}`),
    reorder: (playbookId, stepIds) => apiService.put(`/agent/playbooks/${playbookId}/steps/reorder`, { stepIds }),
  },
  traders: {
    list: () => apiService.get("/agent/traders/"),
    getWeeklyRules: (traderId) => apiService.get(`/agent/traders/${traderId}/weekly-rules`),
    patchWeeklyRules: (traderId, rules) => apiService.patch(`/agent/traders/${traderId}/weekly-rules`, rules),
    listSlots: (traderId, params = {}) => {
      const s = qs(params);
      return apiService.get(`/agent/traders/${traderId}/slots${s ? `?${s}` : ""}`);
    },
    generateSlots: (traderId, weeks = 4) => apiService.post(`/agent/traders/${traderId}/slots/generate`, { weeks }),
    createSlot: (traderId, payload) => apiService.post(`/agent/traders/${traderId}/slots`, payload),
    blockSlot: (traderId, slotId) => apiService.patch(`/agent/traders/${traderId}/slots/${slotId}`, { status: "BLOCKED" }),
    unblockSlot: (traderId, slotId) => apiService.patch(`/agent/traders/${traderId}/slots/${slotId}`, { status: "FREE" }),
    deleteSlot: (traderId, slotId) => apiService.delete(`/agent/traders/${traderId}/slots/${slotId}`),
  },
  appointments: {
    list: (params = {}) => {
      const s = qs(params);
      return apiService.get(`/agent/appointments${s ? `?${s}` : ""}`);
    },
    get: (id) => apiService.get(`/agent/appointments/${id}`),
    cancel: (id, reason) => apiService.post(`/agent/appointments/${id}/cancel`, { reason }),
  },
  notifications: {
    list: (params = {}) => {
      const s = qs(params);
      return apiService.get(`/agent/notifications${s ? `?${s}` : ""}`);
    },
    read: (id) => apiService.post(`/agent/notifications/${id}/read`, {}),
    readAll: () => apiService.post(`/agent/notifications/read-all`, {}),
  },
  health: () => apiService.get("/agent/health"),
};

export default agentApi;
